// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app button{cursor:pointer}.spacing-xs{margin-bottom:var(--wb-spacing-xs)}.user-flyout{padding:var(--wb-spacing-xs)}@media(min-width:48em)and (max-width:47.99em){.headline{margin-top:-.6rem}}.sub-headline{color:var(--wb-grey-20)}.login-button{margin-bottom:var(--wb-spacing-xxs)}.is-logged-in .login-button{margin:0}.block-button{display:block!important;text-align:center!important;width:100%}", ""]);
// Exports
module.exports = exports;
